<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>Employee<span class="head-btn-style">
                    <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                        <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled"
                        title="Save">
                        <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="employees" [actionExclude]="['delete','feedback','column']" [checkboxCol]="true"
            [entityColumns]="employeeColumns" [selectionField]="'Emp_Ref_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addEmployee($event)" (editEntity)="editEmployee($event)"
            (refreshEntities)="refreshEmployee($event)" (deleteEntity)="deleteEmployee($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>
    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearEmployee()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Employee Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                        [fieldName]="'EmployeeCode'" [(ngModel)]="entity.EmployeeCode" ngDefaultControl></textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Salutation'" [formData]="entity" [data]="salutations" [mandatory]="true"
                        [class]="'form-control'" [filterable]="true" (filterChanged)="getAllSalutation($event)"
                        [(ngModel)]="entity.Salutation_Id" [textField]="'DisplayText'"
                        (selectionChanged)="getAllSalutation('')" [valueField]="'DisplayValue'"
                        [fieldName]="'Salutation_Id'" [selectedItem]="selectedSalutation" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Employee Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'EmployeeName'" [(ngModel)]="entity.EmployeeName"
                        (keypress)="AlphabetsOnly($event)" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'HO Staff'" (change)="checkValue()" [(ngModel)]="entity.IsHOStaff"></checkbox>
                </div>
                <!-- <div class="col-md-4 mb-2">
                    <textbox [caption]="'User Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                    [fieldName]="'UserName'" [(ngModel)]="entity.UserName"
                    ngDefaultControl>
                </textbox>
                </div> -->
            </div>
            <div class="row">
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Division'" [formData]="entity" [data]="divisions" [mandatory]="false"
                        [class]="'form-control'" [filterable]="true" (filterChanged)="getAllDivisions($event)"
                        [(ngModel)]="entity.Division_Id" [textField]="'DivisionName'" [valueField]="'Division_Id'"
                        [fieldName]="'Division_Id'" [selectedItem]="selectedDivision" ngDefaultControl>
                    </dropdown>
                </div> -->
                <div class="col-md-4 mb-2" *ngIf="HOStaff">
                    <dropdown [caption]="'Branch'" [formData]="entity" [data]="locations" [mandatory]="true"
                        [class]="'form-control'" [filterable]="true" (filterChanged)="getAllLocations($event)"
                        [(ngModel)]="entity.Location_Id" [textField]="'LocationName'" [valueField]="'Location_Id'"
                        [fieldName]="'Location_Id'" [selectedItem]="selectedLocation" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Department'" [formData]="entity" [data]="departments" [mandatory]="true"
                        [filterable]="true" (filterChanged)="getAllDepartments($event)" [class]="'form-control'"
                        [(ngModel)]="entity.Department_Id" [textField]="'DepartmentName'" [valueField]="'Department_Id'"
                        [fieldName]="'Department_Id'" [selectedItem]="selectedDepartment"
                        (selectionChanged)="SubDepartmentSelection($event)" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Sub Department'" [formData]="entity" [data]="subdepartments"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllSubDepartments($event)"
                        [(ngModel)]="entity.SubDepartment_Id" [textField]="'SubDepartmentName'"
                        [valueField]="'SubDepartment_Id'" [fieldName]="'SubDepartment_Id'" [class]="'form-control'"
                        [selectedItem]="selectedSubDepartment" ngDefaultControl>
                    </dropdown>
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Unit'" [formData]="entity" [data]="units" [mandatory]="false"
                        [filterable]="true" (filterChanged)="getAllUnits($event)" [(ngModel)]="entity.Unit_Id"
                        [textField]="'UnitName'" [valueField]="'Unit_Id'" [fieldName]="'Unit_Id'"
                        [class]="'form-control'" [selectedItem]="selectedUnit" ngDefaultControl>
                    </dropdown>
                </div> -->
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Designation'" [formData]="entity" [data]="designations" [mandatory]="true"
                        [filterable]="true" (filterChanged)="getAllDesignations($event)"
                        [(ngModel)]="entity.Designation_Id" [textField]="'DesignationName'"
                        [valueField]="'Designation_Id'" [fieldName]="'Designation_Id'" [class]="'form-control'"
                        [selectedItem]="selectedDesignation" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Position'" [formData]="entity" [data]="positions" [mandatory]="false"
                        [filterable]="true" (filterChanged)="getAllPositions($event)" [(ngModel)]="entity.Position_Id"
                        [textField]="'PositionName'" [valueField]="'Position_Id'" [fieldName]="'Position_Id'"
                        [class]="'form-control'" [selectedItem]="selectedPosition" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId" ngDefaultControl></textbox>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <label for="file">Private Comments To</label>
                    <kendo-multiselect [data]="userdata" [filterable]="true" (filterChange)="getAllUsers($event)"
                        [textField]="'UserName'" [class]="'form-control'" [valueField]="'User_Id'"
                        [placeholder]="'Private Comments to'" [(ngModel)]="entity.PrivateCommentsTo"
                        ngDefaultControl></kendo-multiselect>
                </div>

                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [formData]="entity" [mandatory]="false" [fieldName]="'Phone'"
                        [(ngModel)]="entity.Phone" (keypress)="numberOnly($event)" [maxlength]="10" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <br>
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label for="file">Secretary</label>
                    <kendo-multiselect [data]="secretarydata" [filterable]="true"
                        (filterChange)="getAllSecretary($event)" [textField]="'secretaryName'" [class]="'form-control'"
                        [valueField]="'Secretary_Emp_Ref_Id'" [placeholder]="'Secretary'" [(ngModel)]="entity.Secretary"
                        ngDefaultControl>
                    </kendo-multiselect>
                </div>

            </div>
            <!-- <div class="col-md-4 mb-2">
                <dropdown [caption]="'Company'" [formData]="entity" [data]="companys" [mandatory]="false"
                    [class]="'form-control'" [filterable]="true" (filterChanged)="getAllCompanys($event)"
                    [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'"
                    [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                </dropdown>
            </div> -->

            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <label for="file">Signature</label>&nbsp;
                    <input id="file-input" type="file" (change)="fileChanged($event);" />
                    <span>
                        <img [src]="url" height="70" class="imgClass">
                        <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                            (click)="removeImage($event);" value="x" />
                    </span>
                </div>
            </div> -->
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                        title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
</ng-template>
<kendo-dialog title="Employee Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="EmployeeCode" class="label label-1">Employee Code : </label> {{details.EmployeeCode}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="EmployeeName" class="label label-1">Employee Name : </label>{{details.Salutation}}
                {{details.EmployeeName }}
            </div>

            <div class="col-md-4 br-table-data">
                <label for="DepartmentName" class="label label-1">Department Name : </label> {{details.DepartmentName}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="SubDepartment" class="label label-1">Sub Department : </label> {{details.SubDepartmentName}}
            </div>

            <div class="col-md-4 br-table-data">
                <label for="DesignationName" class="label label-1">Designation Name : </label>
                {{details.DesignationName}}
            </div>

            <div class="col-md-4 br-table-data">
                <label for="PositionName" class="label label-1">Position Name : </label> {{details.PositionName}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="EmailId" class="label label-1">EmailId : </label> {{details.EmailId}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="Phone" class="label label-1">Phone Number : </label> {{details.Phone}}
            </div>
        </div>
        <br />
        <div>
            <div class="col-md-7 text-bold">
                {{ PrivateComments }}
            </div>
            <grid [entities]="details.PrivateCommentsTo"
                [actionExclude]="['feedback','column','add','edit','delete','download','refresh']" [checkboxCol]="true"
                [entityColumns]="PrivateCommentsColumns"></grid><br><br>
        </div>
    </div>
</kendo-dialog>
<kendo-excelexport [data]="employees.data" [collapsible]="true" fileName="Employee.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmployeeCode" title="Employee Code" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmployeeName" title="Employee Name" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DivisionName" title="Division" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="LocationName" title="Branch" [width]="200">
    </kendo-excelexport-column> -->
    <kendo-excelexport-column field="DepartmentName" title="Department" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="SubDepartmentName" title="Sub Department" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="UnitName" title="Unit" [width]="200">
    </kendo-excelexport-column> -->
    <kendo-excelexport-column field="DesignationName" title="Designation" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="PositionName" title="Position" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmpMail" title="Email" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmpPhone" title="Phone" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>